module.exports = __webpack_public_path__ + "static/media/wallet.f5bd0422.svg";